export const templateLabels = {
  1: "Lista de Espera",
  2: "Cambio de Clase",
  3: "Cambio de Coach",
  4: "Clase Cancelada",
  5: "Verificar WhatsApp",
  6: "Cambio de Coach y Clase",
  7: "Cambio de Horario",
};

export const statusLabels = {
  sent: "Enviada",
  failed: "Fallida",
  queued: "En fila",
  pending: "Pendiente",
  delivered: "Entregada",
  undelivered: "No Entregada",
};
